<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/comSalesIndex/cSellOrderList' }"
          v-if="type == 1"
          >销售业务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/comSalesIndex/cBusinessOrderList' }"
          v-else-if="type == 2"
          >业务订单审核</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cOrderDetail' }"
          >订单详情</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cPaymentList' }"
          >订单支付收款管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{
          formData.id ? "编辑订单支付收款管理" : "新增订单支付收款管理"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>
        {{ formData.id ? "编辑订单支付收款管理" : "新增订单支付收款管理" }}
      </h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>付款方式：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.paytype"
                style="justify-content: space-evenly"
                :disabled="formData.id != ''"
              >
                <el-radio label="微信">微信</el-radio>
                <el-radio label="支付宝">支付宝</el-radio>
                <el-radio label="第三方支付工具">第三方支付工具</el-radio>
                <el-radio label="银行转账">银行转账</el-radio>
                <el-radio label="数字人民币">数字人民币</el-radio>
                <el-radio label="现金支付">现金支付</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>付款金额</p>
            <div class="input_box">
              <el-input
                v-model="formData.paynum"
                placeholder="输入付款金额"
                :readonly="formData.id != ''"
                @input="handleBlurPrice"
              ></el-input>
            </div>
          </div>

          <div
            class="block"
            v-if="
              formData.paytype == '银行转账' ||
              formData.paytype == '数字人民币' ||
              formData.paytype == '第三方支付工具' ||
              formData.paytype == '现金支付'
            "
          >
            <p><span class="mark">*</span>付款抬头</p>
            <div class="input_box">
              <el-input
                v-model="formData.headname"
                placeholder="输入付款抬头"
                :readonly="formData.id != ''"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.paytype == '银行转账'">
            <p><span class="mark">*</span>付款开户行</p>
            <div class="input_box">
              <el-input
                v-model="formData.bankname"
                placeholder="输入付款开户行"
                :readonly="formData.id != ''"
              ></el-input>
            </div>
          </div>
          <div
            class="block"
            v-if="
              formData.paytype == '微信' ||
              formData.paytype == '支付宝' ||
              formData.paytype == '银行转账'
            "
          >
            <p><span class="mark">*</span>付款账号</p>
            <div class="input_box">
              <el-input
                v-model="formData.bankaccount"
                :readonly="formData.id != ''"
                placeholder="输入付款账号"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>
              付款凭证截图 <span class="red">JPG或PNG文件，大小限制2MB</span>
            </p>
            <div
              class="upload_box"
              @mouseenter="creenIndex = 1"
              @mouseleave="handleMouseLeave(1)"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
                :disabled="formData.id != ''"
              >
                <div class="img_box" v-if="formData.shotcut">
                  <img :src="formData.shotcut" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span
                      @click.stop="handlePictureCardPreview(formData.shotcut)"
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="formData.shotcut = ''"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>付款记录审核状态</p>
            <div class="radio_wrap">
              <el-radio-group
                direction="horizontal"
                v-model="formData.checkstate"
                style="justify-content: space-evenly"
                :disabled="type == 1"
              >
                <el-radio label="待审核">待审核</el-radio>
                <el-radio label="已审核">已审核</el-radio>
                <el-radio label="审核驳回">审核驳回</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block" v-if="formData.checkstate == '审核驳回'">
            <p><span class="mark">*</span>驳回原因</p>
            <div class="input_box">
              <el-input
                v-model="formData.checkdetail"
                placeholder="输入驳回原因"
                :readonly="type == 1"
                type="textarea"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query" v-if="formData.id == '' && type == 1">
        确认
      </div>
      <div class="btn" @click="query" v-if="type == 2">保存</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->

    <!-- 放大图片 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" height="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { encryptstringview, uploadPosterImage } from "../../../api/api";
import {
  getOrderListDetail,
  getOrderPaymentDetail,
  addOrderPayment,
  editOrderPayment,
} from "../../../api/shop";
// import { calculator } from "../../../utils/decimal";
export default {
  name: "cPaymentDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      loading: false,
      formData: {
        id: "",
        orderno: "",
        paytype: "",
        headname: "",
        bankname: "",
        bankaccount: "",
        paynum: "",
        paytotal: "",
        remain: "",
        shotcut: "",
        createuser: "",
        checkstate: "待审核", // 付款记录审核状态 =待审核 已审核 审核驳回
        checkdetail: "", // 驳回原因
        checkuser: "",
      },
      dataItem: "",
      orderId: "",
      orderOpenid: "",
      type: "", //
      USERINFO: "",

      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.USERINFO = USERINFO;
    this.formData.createuser = USERINFO.truename;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { orderno, id, orderId, orderOpenid, type } = JSON.parse(
          res.jsondata
        );
        this.orderId = orderId;
        this.orderOpenid = orderOpenid;
        this.formData.orderno = orderno;
        this.type = type;
        if (id != "") {
          this.formData.id = id;
          this.getOrderPaymentDetail(id);
        }

        this.getOrderListDetail(orderId, orderOpenid);
      } else {
        this.$router.back();
      }
    },
    // 获取详情
    getOrderPaymentDetail(id) {
      getOrderPaymentDetail({ id }).then((res) => {
        this.detail = res;
        this.formData.id = res.id;
        this.formData.paytype = res.paytype;
        this.formData.headname = res.headname;
        this.formData.bankname = res.bankname;
        this.formData.bankaccount = res.bankaccount;
        this.formData.paynum = res.paynum;
        this.formData.paytotal = res.paytotal;
        this.formData.remain = res.remain;
        this.formData.createuser = res.createuser;
        this.formData.checkstate = res.checkstate ? res.checkstate : "";
        this.formData.checkdetail = res.checkdetail ? res.checkdetail : "";
        this.formData.checkuser = res.checkuser ? res.checkuser : "";
        this.formData.shotcut = res.shotcut ? res.shotcut : "";
      });
    },

    // 订单列表
    getOrderListDetail(id, openid) {
      let params = {
        openid: openid,
        orderid: id,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        // this.formData.paynum = newObj.price;
        this.formData.paytotal = newObj.price_original;
        // this.formData.remain = newObj.diffrentprice;
        this.loading = false;
      });
    },

    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 移除
    handleMouseLeave(creenIndex) {
      let { formData } = this;
      if (creenIndex == 1 && formData.shotcut != "") {
        this.creenIndex = "";
      }
    },
    beforeUpload(file) {
      // 设置最大文件大小（例如：2MB）
      const maxSize = 2 * 1024 * 1024; // 2MB

      if (file.size > maxSize) {
        this.$message.error("上传的图片大小不能超过 2MB!");
        return false; // 返回 false 则停止上传
      }

      return true; // 返回 true 则继续上传
    },
    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          if (creenIndex == 1) {
            this.formData.shotcut = res.url;
            loading.close();
          }
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 价格输入失去焦点
    handleBlurPrice() {
      let { paynum } = this.formData;
      let newPrice = paynum.replace(/^(\d*(?:\.\d{0,2})?).*$/, "$1");
      this.formData.paynum = newPrice;
      // this.formData.remain = calculator(paytotal)
      //   .subtract(Number(newPrice))
      //   .toNumber();
    },

    query() {
      let { formData, type, USERINFO } = this;
      if (formData.paytype == "") {
        this.$message.warning("请选择付款方式");
        return;
      }
      if (formData.paynum == "") {
        this.$message.warning("请输入付款金额");
        return;
      }
      if (
        formData.paytype == "银行转账" ||
        formData.paytype == "数字人民币" ||
        formData.paytype == "第三方支付工具" ||
        formData.paytype == "现金支付"
      ) {
        if (formData.headname == "") {
          this.$message.warning("请输入付款抬头");
          return;
        }
      }
      if (formData.paytype == "银行转账") {
        if (formData.bankname == "") {
          this.$message.warning("请输入付款开户行");
          return;
        }
      }

      if (
        formData.paytype == "微信" ||
        formData.paytype == "支付宝" ||
        formData.paytype == "银行转账"
      ) {
        if (formData.bankaccount == "") {
          this.$message.warning("请输入付款账号");
          return;
        }
      }

      if (type == 2) {
        this.formData.checkuser = USERINFO.truename;
        if (formData.checkstate === "") {
          this.$message.warning("请选择付款记录审核状态");
          return;
        }
        if (formData.checkstate == "审核驳回" && formData.checkdetail == '') {
          this.$message.warning("请输入驳回原因");
          return;
        }
      }

      if (formData.id) {
        this.editOrderPayment();
      } else {
        this.addOrderPayment();
      }
    },

    // 修改
    editOrderPayment() {
      this.loading = true;
      editOrderPayment(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 新增
    addOrderPayment() {
      this.loading = true;
      addOrderPayment(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
  .red {
    color: red;
    font-size: 14px;
  }
  // .el-radio {
  //   &.is-disabled {
  //     .el-radio__label {
  //       color: #6e6e6e !important;
  //     }
  //   }
  // }
  /deep/.el-radio.is-disabled .el-radio__label {
    color: #999; /* 例如，改变标签颜色为灰色 */
  }
}
</style>